import React, { useRef } from "react";
import { Modal } from "react-bootstrap";
import { errorMessage, formatDate, formatStatus } from "../../../../util/Helpers";
import DynamicSimpleTable from "../../../../util/DynamicSimpleReactTable";
import cogoToast from "cogo-toast";
import { DownloadIcon } from "../../../../util/Icons";
import { useGenerateDownloadURLMutation } from "../../../../../redux/apiSlice";

export const ReportsModal = ({ showReportsModal, onHide }) => {
    const tableRef = useRef();
    const [
        generateDownloadURL
     ] = useGenerateDownloadURLMutation()

    const downloadReport = (id, fileName) => {
        generateDownloadURL(id)
            .unwrap()
            .then((payload) => {
                const a = document.createElement('a')
                a.download = fileName
                a.href = payload
                const clickEvt = new MouseEvent('click', {
                    view: window,
                    bubbles: true,
                    cancelable: true,
                })
                a.dispatchEvent(clickEvt)
                a.remove()
            })
    }

    /* Action Buttons */
    const reportAction = (row) => {
        const canDownload = row.status.toLowerCase() === "completed"
        return (
            <span style={{ whiteSpace: "nowrap" }}>
                <button
                    className={`btn btn-icon btn-light btn-hover-primary btn-sm mx-3`}
                    onClick={() => downloadReport(row.id, row.fileName)}
                    disabled={!canDownload}
                >
                    <span className={`svg-icon svg-icon-md`}>
                        <DownloadIcon />
                    </span>
                </button>
            </span>
        );
    };

    return (
        <Modal
            show={showReportsModal}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            size="xl"
        >

            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    Reports
                </Modal.Title>
                <button type="button" className="close" onClick={onHide}>
                    <span aria-hidden="true" className="d-block">×</span>
                    <span className="sr-only">Close</span>
                </button>
            </Modal.Header>
            <Modal.Body
                className="px-10 py-2"
            >
                <DynamicSimpleTable
                    source={{ url: `/admins/reports` }}
                    columns={[
                        { title: "NAME", key: "fileName" },
                        { title: "STATUS", format: (row) => formatStatus(row.status) },
                        { title: "CREATED ON", format: (row) => formatDate(row.createdAt) },
                        { title: "", format: reportAction },
                    ]}
                    ref={tableRef}
                    onError={(err) =>
                        cogoToast.error(errorMessage(err))
                    }
                    refreshIcon={true}
                />
            </Modal.Body>
        </Modal>
    );
}